export const serve_address =
  process.env.NEXT_PUBLIC_APP_ENV === "production"
    ? "https://api.karatdao.com/action"
    : process.env.NEXT_PUBLIC_API_HOST ||
      "https://api-dev.karatdao.com/test_backend/lemon/action";

export const walletconnect_project_id = "031d2b33f0e66c821d14c5bbaaa6b611";

export const TDK = {
  title: "KaratForm: NFT Allowlist Collection Tool",
  description:
    "Easiest way to onboard web3 users with twitter, discord, and telegram. Launch a KaratForm to track and gain insights about your community under just one minute!",
  keywords:
    "KaratForm,Words: Premint Alternative,NFT allowlist,NFT allowlist,Wallet Collector,Address Collector,Wallet Management",
  cover: "https://s2.loli.net/2022/10/09/y4OKohqxgjZpT3W.jpg",
};
